import { Injectable } from '@angular/core';
import { CfaAuthor } from '../models/cfa-author';
import { BehaviorSubject, combineLatestWith, delayWhen, filter, map, Observable, shareReplay, tap, timer } from 'rxjs';
import { CfaStateService } from './cfa-state.service';

@Injectable({providedIn: 'root'})
export class PublishStateService {
    
    constructor(private _cfaStateService: CfaStateService) {}

    private _cfaAuthor?: CfaAuthor;

    cfaAuthor$ = new BehaviorSubject<CfaAuthor | undefined>(this._cfaAuthor);
    isPublished$: Observable<boolean> = this.cfaAuthor$.pipe(
        map(cfaAuthor => cfaAuthor?.author ? true : false),
        shareReplay(1)
    )
    firstPublishStarted$ = new BehaviorSubject<boolean>(false);
    firstPublishLoading$ = new BehaviorSubject<boolean>(false);
    firstRing$ = new BehaviorSubject<boolean>(false);
    firstPublishCompleted$ = this.firstPublishStarted$.pipe(
        // combineLatestWith(timer(5*1000)),
        combineLatestWith(this.isPublished$),
        filter(([started, published]) => started && published),
        // delayWhen(() => timer(5*1000)),
        map(() => true),
        tap(() => {
            console.log("Reporting complete publish");
            setTimeout(() => {
                this.stopFirstPublishLoading();
            }, 3000);
        }),
        shareReplay(1)
    );
    firstPublishConfirmed$ = new BehaviorSubject<boolean>(false);


    get cfaAuthor(): CfaAuthor | undefined {
        return this._cfaAuthor;
    }

    set cfaAuthor(author: CfaAuthor) {
        this._cfaAuthor = author;
        this.cfaAuthor$.next(author);
    }

    beginFirstPublish() {
        if (this.cfaAuthor && !this.cfaAuthor.author && !this.cfaAuthor.firstPublishConfirmed) {
            this.firstPublishStarted$.next(true);
            this.firstPublishLoading$.next(true);
        }
    }    

    stopFirstPublishLoading() {
        this.firstPublishLoading$.next(false);
    }

    confirmFirstPublish() {
        this.firstPublishConfirmed$.next(true);
        this._cfaStateService.refreshCfaAuthor();
    }

    firstRing() {
        this.firstRing$.next(true);
    }
}